import { render, staticRenderFns } from "./ManageDesignations.vue?vue&type=template&id=bd565120"
import script from "./ManageDesignations.vue?vue&type=script&lang=js"
export * from "./ManageDesignations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports